var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"id":"sus-view-cart","href":"/cart"},on:{"click":_vm.openCart}},[_c('i',{staticClass:"fas fa-shopping-bag"}),_vm._v(" "),_c('span',{staticClass:"sus-view-cart__count"},[_vm._v(_vm._s(_vm.cartCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }